var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixSelect = React.forwardRef(function (_a, ref) {
    var options = _a.options, wrapperClassName = _a.wrapperClassName, className = _a.className, label = _a.label, id = _a.id, placeholder = _a.placeholder, _b = _a.hasError, hasError = _b === void 0 ? false : _b, required = _a.required, props = __rest(_a, ["options", "wrapperClassName", "className", "label", "id", "placeholder", "hasError", "required"]);
    var uiTheme = useDataUiTheme();
    var fallbackId = React.useRef("radix-select-".concat(Math.random().toString(36).slice(2, 10)));
    var selectId = id || fallbackId.current;
    return (React.createElement("div", { className: ["radix-select-wrapper", wrapperClassName].filter(Boolean).join(" "), "data-invalid": hasError ? "true" : undefined, "data-ui-theme": uiTheme },
        label ? React.createElement("label", { className: "radix-select-label", htmlFor: selectId }, label) : null,
        React.createElement("div", { className: "radix-select-control" },
            React.createElement("select", __assign({}, props, { ref: ref, id: selectId, className: ["radix-select", className].filter(Boolean).join(" "), "aria-invalid": hasError ? "true" : props["aria-invalid"], required: required }),
                placeholder ? React.createElement("option", { value: "", disabled: true }, placeholder) : null,
                options.map(function (option) { return React.createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.label); })),
            React.createElement("span", { className: "radix-select-chevron", "aria-hidden": "true" }, "\u25BE"))));
});
RadixSelect.displayName = "RadixSelect";
